<template>
  <div class="time-content flex-col">
    <div class="kf-box flex-row">
      <div class="time-data-box">
        <div class="time-icon-box flex-row justify-between">
          <img class="img-icon" referrerpolicy="no-referrer" src="../../../assets/time-kf.png" />
          <span class="icon-info">Opening&nbsp;hours</span>
        </div>
        <span class="time-title">开放时间</span>
      </div>
      <div class="time_data_box">
        <div class="campus-switch">
          <span :class="['campus-item', { active: currentCampus === 'guoshun' }]" @click="switchCampus('guoshun')">国顺院区
            <i v-if="currentCampus === 'guoshun'" class="triangle-down"></i></span>
          <span :class="['campus-item', { active: currentCampus === 'zhengli' }]"
            @click="switchCampus('zhengli')">政立院区<i v-if="currentCampus === 'zhengli'" class="triangle-down"></i></span>
        </div>
        <div class="campus-time">
          <span>{{ currentCampusTime }}</span>
          <span>(周一至周日)</span>
        </div>
      </div>
    </div>
    <div class="yy-box flex-row">
      <div class="flex-col justify-between">
        <div class="time-icon-box flex-row">
          <img class="img-icon" referrerpolicy="no-referrer" src="../../../assets/time-yy.png" />
          <span class="icon-info">Seats&nbsp;Taken</span>
        </div>
        <span class="time-title">座位已预约</span>
      </div>
      <div style="margin: 0px 0 0 20px;">
        <span class="time-show-data">{{ siteData?.used }}</span>
        <span class="time-show-data2">/{{ siteData?.total }}</span>
      </div>
    </div>
    <div class="zg-box flex-row" v-if="currentCampus === 'guoshun'">
      <div class="in_box flex-col justify-between">
        <div class="time-icon-box flex-row justify-between">
          <img class="img-icon" referrerpolicy="no-referrer" src="../../../assets/time-zg.png" />
          <span class="icon-info">In-Library&nbsp;Readers</span>
        </div>
        <span class="time-title">进馆人次</span>
      </div>
      <div style="margin:0px 0px 0px 11px">
        <span class="time-show-data">{{ flowData?.inCount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { post, get } from "@u/request";
export default {
  name: "",
  components: {},
  props: {},
  data () {
    return {
      currentCampus: 'guoshun',
      campusTime: {
        guoshun: '8:00-22:00',
        zhengli: '10:00-20:00'
      },
      siteData: {
        total: 0,
        used: 0,
      },
      flowData: {
        inCount: 0,
        outCount: 0,
      },
    };
  },
  watch: {
    $route: {
      handler (to) {
        this.isPosition = to.path === "/home";
      },
      immediate: true,
    },
  },
  computed: {
    currentPath () {
      return this.$route.path;
    },
    currentCampusTime () {
      return this.campusTime[this.currentCampus];
    }
  },
  methods: {
    searchSubmit () {
      if (this.searchValue) {
        let form = document.getElementById("cgForm");
        form.submit();
      }
    },
    async getPassengerFlow () {
      const { rows } = await get("lib/passengerFlow/list");
      if (rows && rows.length > 0) {
        this.flowData = rows[0];
      }
    },
    async getSiteList () {
      const { data } = await get("lib/index/siteList");
      const siteList = data.data;

      // 根据当前选中的院区进行过滤
      const filteredSiteList = siteList.filter(item => {
        if (this.currentCampus === 'zhengli') {
          return item.name === '政立院区';
        } else if (this.currentCampus === 'guoshun') {
          return item.name !== '政立院区';
        }
        return true;
      });

      const siteData = filteredSiteList.reduce(
        (obj, item) => {
          obj.total += item.total;
          obj.used += item.used;
          return obj;
        },
        { total: 0, used: 0 }
      );
      this.siteData = siteData;
    },
    switchCampus (campus) {
      this.currentCampus = campus;
      this.getSiteList(); // 切换院区时重新获取数据
    },
  },
  mounted () {
    this.getSiteList();
    this.getPassengerFlow();
  },
};
</script>

<style scoped lang="scss">
.time-content {
  height: 229px;
  background: url(../../../assets/time-bg.png) -16px 0px no-repeat;
  background-size: 516px 251px;
  width: 500px;
  // position: absolute;
  // left: 181px;
  // top: 370px;
  z-index: 2;
  padding-left: 20px;
}

.img-icon {
  width: 16px;
  height: 16px;
}

.icon-info {
  height: 13px;
  overflow-wrap: break-word;
  color: #909399;
  font-size: 12px;
  font-weight: 250;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-left: 4px;
}

.time-title {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 22px;
  text-align: left;
  white-space: nowrap;
  line-height: 33px;
  margin-top: 3px;
}

.in_box {
  margin-top: 10px;
}

.time-data-box {
  margin-top: 20px;
}

.time-icon-box {
  margin-left: 1px;
}

.time-show-data {
  overflow-wrap: break-word;
  color: rgba(255, 147, 56, 1);
  font-size: 28px;
  text-align: left;
  white-space: nowrap;
  line-height: 48px;
  // margin: 13px 0 0 38px;
}

.time-show-data2 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 21px 0 0 3px;
}

.time_data_box {
  color: #fff;
  font-size: 20px;
  margin: 13px 0 0 20px;

  >div {
    margin-bottom: 10px;

    >span:nth-child(1) {
      margin-right: 10px;
    }
  }
}

.kf-box {
  align-items: center;

  // height: 45px;
}

.yy-box {
  // margin: 27px 0 0 22px;
  align-items: center;
}

.zg-box {
  // margin: 31px 0 22px 22px;
  margin-top: 10px;
}

.campus-switch {
  margin-bottom: 15px;

  .campus-item {
    cursor: pointer;
    padding: 5px 10px;
    margin-right: 10px;
    border-radius: 4px;
    position: relative;
    color: #65A0CF;

    &.active {
      color: rgba(255, 147, 56, 1);
    }

    .triangle-down {
      position: absolute;
      left: 50%;
      bottom: -2px;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid rgba(255, 147, 56, 1);
    }
  }
}

.campus-time {
  font-size: 20px;
  padding: 5px 10px;
  span:first-child {
    margin-right: 10px;
  }
}
</style>
